module.exports = __webpack_public_path__ + "img/icon-youtube.11dd7ac6.svg";